import { lazy } from 'react';

import { VOLUNTEER_CALLS_ENABLED } from '@/config/features';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de chamados.
 *
 * Fica **dentro** do `AppLayout` e sob `RequireSession`: é tela-destino do menu
 * (a barra continua com os cinco itens decididos), e a RLS não devolve chamado
 * nenhum para convidado — uma tela vazia atrás de um item de menu seria pior que
 * o gate honesto do login.
 */
const CallsPage = lazy(() => import('./routes/Calls.page'));
const InstitutionCallsPage = lazy(() => import('./routes/InstitutionCalls.page'));

/**
 * ⚠️ **Vazias enquanto `VOLUNTEER_CALLS_ENABLED` for `false`** (2026-09-20, por
 * decisão de produto — ver `config/features.ts`). As duas telas continuam
 * importadas e verificadas pelo `typecheck`; o que a bandeira tira é a porta.
 *
 * A fila que ficou no lugar de `/calls` é o **mural de vagas**, em `/openings`,
 * no módulo de instituições — que é onde a vaga já morava.
 */
export const callsRoutes: RouteObject[] = VOLUNTEER_CALLS_ENABLED
  ? [{ path: 'calls', element: <CallsPage /> }]
  : [];

/**
 * Gestão dos chamados de uma instituição — fluxo de tarefa, **fora** do
 * `AppLayout` e sob `RequireSession`, como a gestão da instituição.
 *
 * O caminho fica sob `institutions/:id` porque o recurso é da instituição; o
 * **módulo** que o serve é este. É o que permite a tela de gestão apontar para
 * cá por URL, sem que `institutions` importe UI daqui (docs/01, opção 1).
 */
export const callsProtectedRoutes: RouteObject[] = VOLUNTEER_CALLS_ENABLED
  ? [{ path: 'institutions/:id/calls', element: <InstitutionCallsPage /> }]
  : [];
